import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable max-len */
export function ExpandLessIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M 12 8 L 6 14 L 7.41 15.41 L 12 10.83 L 16.59 15.41 L 18 14 L 12 8 Z",
      fill: "black",
      transform: "matrix(-1, 0, 0, -1, 24, 23.41)"
    })
  });
}